import {
    booleanAttribute, Directive, HostBinding, Input
} from "@angular/core";

/**
 * Toggles the `mgd-field-warning` CSS class on a `mat-form-field` to give it a soft,
 * non-blocking warning appearance — distinct from Angular's built-in error state.
 *
 * This is purely cosmetic: it does not register a validator, does not affect the
 * control's validity, and does not interact with `mat-error`/`mat-hint` rendering.
 * Pair it with a `mat-hint` describing the warning so the user understands why the
 * field is highlighted.
 *
 * @example
 * ```html
 * <mat-form-field [mgdFieldWarning]="isUnusualValue">
 *   <mat-label>UPC</mat-label>
 *   <input matInput formControlName="upc">
 *   @if (isUnusualValue) {
 *     <mat-hint>This value is unusual for the selected category.</mat-hint>
 *   }
 * </mat-form-field>
 * ```
 *
 * @selector mat-form-field[mgdFieldWarning]
 */
@Directive({
    selector: "mat-form-field[mgdFieldWarning]"
})
export class FieldWarningDirective {

    @HostBinding("class.mgd-field-warning")
    @Input({ transform: booleanAttribute }) mgdFieldWarning: boolean;
}
